/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Char_LabelInputs */

const en_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Event On Character`)
};

const fr_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'evenement sur caractere`)
};

const de_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis für Charakter beenden`)
};

const it_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina l'evento sul personaggio`)
};

const ru_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершение события на персонаже`)
};

const es_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento final en el personaje`)
};

const zh_cn2_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色结束事件`)
};

const ja_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャラクターのイベント終了`)
};

const hi_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चरित्र पर घटना समाप्त करें`)
};

const pt_pt2_plain_text_import_end_event_char_label = /** @type {(inputs: Plain_Text_Import_End_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar evento no personagem`)
};

/**
* | output |
* | --- |
* | "End Event On Character" |
*
* @param {Plain_Text_Import_End_Event_Char_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_char_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Char_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Char_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_end_event_char_label(inputs)
	if (locale === "de") return de_plain_text_import_end_event_char_label(inputs)
	if (locale === "it") return it_plain_text_import_end_event_char_label(inputs)
	if (locale === "ru") return ru_plain_text_import_end_event_char_label(inputs)
	if (locale === "es") return es_plain_text_import_end_event_char_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_end_event_char_label(inputs)
	if (locale === "ja") return ja_plain_text_import_end_event_char_label(inputs)
	if (locale === "hi") return hi_plain_text_import_end_event_char_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_end_event_char_label(inputs)
	return en_plain_text_import_end_event_char_label(inputs)
});